export default __webpack_public_path__ + "static/media/rf-20-2022.cdb7b349.pdf";